
import Vue from 'vue'

import CardItem from '@/magazine/components/CardItem.vue'

import { getMagazineAllTypes } from '@/magazine/services'
import {
  magazineAllTypes as MagazineAllTypes,
  MagazineCard
} from '@/magazine/types'
import {
  MAGAZINE_TYPE_BASE_URLS,
  MAGAZINE_TYPES_MAX_ARTICLE_PER_TYPES,
  CMS_CATEGORY_URL_QUERY,
  MAGAZINE_TYPES
} from '@/magazine/consts'
import { SYSTEM_ERROR } from '@/common/constants'
export default Vue.extend({
  components: {
    CardItem
  },
  data(): {
    magazineTypes: MagazineAllTypes | null
    hasMoreColumn: boolean
    hasMoreFeature: boolean
    hasMoreCategory: boolean
  } {
    return {
      magazineTypes: null,
      hasMoreColumn: false,
      hasMoreFeature: false,
      hasMoreCategory: false
    }
  },
  computed: {
    columnMagazines(): MagazineCard[]  {
      return this.magazineTypes?.columnMagazine?.items || []
    },
    featureMagazines(): MagazineCard[] {
      return this.magazineTypes?.featureMagazine?.items || []
    },
    categoryCMS(): MagazineCard[] {
      return this.magazineTypes?.cmsCategories?.items || []
    },
    columnBaseUrl(): string {
      return MAGAZINE_TYPE_BASE_URLS.COLUMN
    },
    featureBaseUrl(): string {
      return MAGAZINE_TYPE_BASE_URLS.FEATURE
    },
    categoryBaseUrl(): string {
      return MAGAZINE_TYPE_BASE_URLS.CATEGORY
    },
    cmsCategoryUrlQueries(): {[key: string]: string} {
      return CMS_CATEGORY_URL_QUERY
    },
    MAGAZINE_TYPES() {
      return MAGAZINE_TYPES
    }
  },
  async created() {
    const { data } = await getMagazineAllTypes(MAGAZINE_TYPES_MAX_ARTICLE_PER_TYPES).catch(() => alert(SYSTEM_ERROR.UNKNOWN))
    if (data) {
      this.magazineTypes = data
      if (this.magazineTypes?.columnMagazine?.totalItemsCount > MAGAZINE_TYPES_MAX_ARTICLE_PER_TYPES) this.hasMoreColumn = true
      if (this.magazineTypes?.featureMagazine?.totalItemsCount > MAGAZINE_TYPES_MAX_ARTICLE_PER_TYPES) this.hasMoreFeature = true
      if (this.magazineTypes?.cmsCategories?.totalItemsCount > MAGAZINE_TYPES_MAX_ARTICLE_PER_TYPES) this.hasMoreCategory = true
    }
  }
})
